<template>
  <div class="carousel-container" v-if="miniCards.length">
    <v-card
      v-for="(item, index) in miniCards"
      :key="index + '-mini'"
      class="mini-card"
      height="300"
      width="200"
    >
      <v-btn
        v-if="item.isFavorite !== undefined"
        v-on:click.native="$emit('changeFavorite', item)"
        color="gray"
        dark
        small
        absolute
        top
        right
        fab
        class="mt-6 mr-0"
      >
        <v-icon :color="item.isFavorite ? 'pink' : 'white'" dark>
          mdi-heart
        </v-icon>
      </v-btn>
      <div class="d-flex justify-center mt-8">
        <v-avatar size="120" color="grey lighten-3">
          <v-img
            :src="item.image"
            :contain="!item.hasPhoto"
            :class="item.hasPhoto ? 'enlargeable' : 'pa-2'"
            @click.native="item.hasPhoto && (lightboxSrc = item.image)"
          />
        </v-avatar>
      </div>
      <!-- Always rendered, so a dog with no call name keeps the same card shape as
           one that has it. -->
      <div class="ml-1 mt-1 call-name">{{ item.callName }}</div>
      <h5 class="ml-1">
        <router-link v-if="item.titleLink" :to="item.titleLink">{{
          item.title | truncate(85)
        }}</router-link
        ><span v-else>{{ item.title | truncate(85) }}</span>
      </h5>
      <router-link v-if="item.link" :to="item.link">
        <v-btn class="ml-1 mt-2" color="primary" small dark>{{
          item.buttonText
        }}</v-btn>
      </router-link>
      <v-btn
        v-if="item.action"
        v-on:click.native="$emit('click', item)"
        class="ml-1 mt-2"
        color="primary"
        small
        dark
        >{{ item.buttonText }}</v-btn
      >
    </v-card>
    <photo-lightbox
      :value="!!lightboxSrc"
      :src="lightboxSrc"
      @input="lightboxSrc = ''"
    />
  </div>
  <div
    v-else
    style="
      height: 347px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <h1>No results found</h1>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PhotoLightbox from "@/components/common/PhotoLightbox.vue";

export default Vue.extend({
  name: "CarouselCard",
  components: {
    PhotoLightbox,
  },
  props: {
    miniCards: Array,
  },
  data: function () {
    return {
      lightboxSrc: "",
    };
  },
});
</script>

<style scoped>
.call-name {
  /* Reserved whether or not the dog has a call name, so every card keeps its shape. */
  min-height: 1.25em;
  line-height: 1.25em;
  font-size: 0.875rem;
}
</style>
